export default "__VITE_ASSET__3FPBtVXC__"